import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";

const DEBUG = true;

const logger = {
  info(message, payload) {
    if (typeof window === "undefined") return;
    if (window.__ZIGGY_DEBUG__ !== true) return;
    if (!DEBUG) return;
    console.info(`[RelatedItemsSwiper] ${message}`, payload ?? "");
  },
};

/*function initRelatedItemsSwipers(root = document) {
  if (!window.matchMedia("(min-width: 1024px)").matches) return;
  root.querySelectorAll("[data-related-items-swiper]").forEach(initOne);
}*/

function initRelatedItemsSwipers(root = document) {
  const selector = window.matchMedia("(min-width: 1024px)").matches
    ? "[data-items-list-swiper], [data-items-list-swiper-desktop]"
    : "[data-items-list-swiper], [data-items-list-swiper-mobile]";
  root.querySelectorAll(selector).forEach(initOne);
}

function initOne(el) {
  if (el.__swiper) return;

  const pagination = el
    .closest(".composer__items-list")
    ?.querySelector(".featured-collections-pagination");

  const navigationNext = el
    .closest(".composer__items-list")
    ?.querySelector(".featured-collections-next");

  const navigationPrev = el
    .closest(".composer__items-list")
    ?.querySelector(".featured-collections-prev");

  logger.info("init");

  el.__swiper = new Swiper(el, {
    modules: [Pagination, Navigation],
    slidesPerView: "auto",
    spaceBetween: 14,
    grabCursor: true,
    preventClicks: true,
    preventClicksPropagation: true,
    threshold: 12,
    loop: false,
    centerInsufficientSlides: true,
    watchOverflow: true,

    // mobile first
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,

    breakpoints: {
      1024: {
        spaceBetween: 20,
        slidesOffsetBefore: 28,
        slidesOffsetAfter: 28,
      },
    },
    pagination: pagination
      ? {
          el: pagination,
          clickable: true,
        }
      : undefined,
    navigation:
      navigationNext && navigationPrev
        ? {
            nextEl: navigationNext,
            prevEl: navigationPrev,
          }
        : undefined,

    on: {
      init(swiper) {
        fixSwiperOffsetGap(swiper);
      },
      update(swiper) {
        fixSwiperOffsetGap(swiper);
      },
      resize(swiper) {
        fixSwiperOffsetGap(swiper);
      },
    },
  });
}

/**
 * Fix Swiper snap positions when slidesOffsetBefore
 * is larger than spaceBetween.
 *
 * Prevents previous slide bleed on desktop layouts
 * while preserving template gutters.
 */
function fixSwiperOffsetGap(swiper) {
  const diff = swiper.params.slidesOffsetBefore - swiper.params.spaceBetween;

  if (diff <= 0) return;

  const lastIndex = swiper.snapGrid.length - 1;

  swiper.snapGrid = swiper.snapGrid.map((value, index) => {
    if (index === 0 || index === lastIndex) return value;
    return value + diff;
  });
}

initRelatedItemsSwipers();

window.addEventListener("resize", () => {
  initRelatedItemsSwipers();
});
